
        <ng-content></ng-content>
    


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/grid/column/column.component.ts.ColumnComponent.html